import { useState } from "react";
import { ButtonGroup, Flex } from "orcs-design-system";

import InboxEmpty from "./InboxEmpty";
import InboxListCard from "./InboxListCard";
import {
  matchesTypeFilter,
  type InboxItem,
  type InboxTypeFilter,
} from "./inboxItem";

const FILTERS = [
  { value: "EVERYTHING", label: "Everything" },
  { value: "APPROVALS", label: "Approvals" },
] as const satisfies readonly { value: InboxTypeFilter; label: string }[];

const InboxList = ({
  items,
  selectedKey,
  onSelect,
}: {
  items: InboxItem[];
  selectedKey: string | null;
  onSelect: (key: string) => void;
}) => {
  const [filter, setFilter] = useState<InboxTypeFilter>("EVERYTHING");
  const visible = items.filter((item) => matchesTypeFilter(item, filter));
  return (
    <Flex flexDirection="column" gap="s" width="100%">
      <ButtonGroup
        name="inbox-type-filter"
        items={FILTERS}
        value={filter}
        onChange={setFilter}
        aria-label="Show"
      />
      {visible.length === 0 ? <InboxEmpty /> : null}
      <Flex flexDirection="column" gap="xs">
        {visible.map((item) => (
          <InboxListCard
            key={item.key}
            item={item}
            selected={item.key === selectedKey}
            onSelect={onSelect}
          />
        ))}
      </Flex>
    </Flex>
  );
};

export default InboxList;
